import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import ps_orders from './modules/ps_order'
import ps_order_detail from './modules/ps_order_detail'
import static_ref from './modules/static_ref'
import td_todo from './modules/td_todo'
import td_comment from './modules/td_comment'
import td_action from './modules/td_action'
import td_status from './modules/td_status'
import ps_order_return from './modules/ps_order_return'
import createPersistedState from "vuex-persistedstate";
import td_ginkoia_price from './modules/td_ginkoia_price';
import bc_stock from './modules/bc_stock';

Vue.use(Vuex);

export const store = new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
        auth,
        ps_orders,
        ps_order_detail,
        td_ginkoia_price,
        static_ref,
        td_todo,
        td_comment,
        td_action,
        td_status,
        ps_order_return,
        bc_stock
    }
});